module.exports = __webpack_public_path__ + "media/components/EmptyStateHolder/variable_icon-7162756f6144881fa475fdceff253755.png";